<template lang="pug">
  section.TourView(ref="root")
    .TourView_bg(ref="background")
      PageTransitionLayer.TourView_transitionLayer(v-if="!fancyZoomAnimation")
    .TourView_contentContainer(ref="content" v-if="data && !isTransitioning")

      TourCover(:item="data")

      ButtonPodcast( :url="data._data.attributes.podcast_url.uri" , v-if="data._data.attributes.podcast_url !== null")

      TourIntroduction(:title="data._data.attributes.introduction_title", :content="data._data.attributes.introduction_content")

      ChaptersNav(
        :chapters="chaptersEls"
      )
      TourChapter(
        v-for="(item, index) in data.chapters"
        :key="item.id"
        :item="item"
        @mounted="(c) => onChapterMounted(c.$el, index)"
        @beforeDestroy="(c) => onChapterBeforeDestroy(c.$el, index)"
      )

      TourSupport

      ScrollTop
      //- .TourListContainer
        //- .HorizontalScrollView_bg
        //- .HorizontalScrollView_bgTile.HorizontalScrollView_bgTile-back
        //- BackgroundRelief
      TourList(:withoutWheel="false").TourList

      //-  TourList
</template>

<script>

import TourModel from '@/models/TourModel'
import BackgroundRelief from '@/components/common/BackgroundRelief'
import TourCover from '@/components/TourCover'
import TourIntroduction from '@/components/TourIntroduction'
import TourChapter from '@/components/TourChapter'
import TourList from '@/components/TourList'
import TourSupport from '@/components/TourSupport'
// import TourQuizz from '@/components/TourQuizz'
import customTransitionMixins from '@/mixins/customTransitionMixins'
import { TweenLite, TimelineLite } from 'gsap'
import PageTransitionLayer from '@/components/PageTransitionLayer'
import ChaptersNav from '@/components/ChaptersNav'
import ScrollTop from '@/components/common/ScrollTop'
import COLOR from '@/const.colors.js'
import ButtonPodcast from '@/components/common/ButtonPodcast'
const { sessionStorage } = window

export default {
  mixins: [customTransitionMixins],
  name: 'tour-view',
  props: ['uuid'],
  components: {
    TourIntroduction,
    TourCover,
    TourChapter,
    TourSupport,
    TourList,
    BackgroundRelief,
    PageTransitionLayer,
    ChaptersNav,
    ScrollTop,
    ButtonPodcast
  },
  data () {
    return {
      COLOR,
      data: null,
      meta: {
        title: null,
        description: null,
        canonical: null
      },
      chaptersEls: [], // liste des éléments root des chapitres
      isTransitioning: false,
      transitionBg: false,
      clickedThumbRect: sessionStorage.getItem('tourThumbRect') ? JSON.parse(sessionStorage.getItem('tourThumbRect')) : false
    }
  },
  metaInfo () {
    return this.meta
  },
  computed: {
    fancyZoomAnimation () {
      return !!this.clickedThumbRect
    }
  },
  watch: {
    // call again the method if the route changes
    '$route': 'fetchData'
  },
  created () {
    this.fetchData()
    this.fetchMeta()
  },
  methods: {
    fetchData () {
      this.$api.getTour(this.$i18n.locale, this.uuid)
        .then(response => {
          this.data = new TourModel(response.data)
        })
    },
    fetchMeta () {
      this.$api.getPageMetaTag(this.$i18n.locale, this.uuid)
        .then(response => {
          this.meta = this.$metatag.formateMeta(response.data)
        })
    },
    /**
     * Override la méthode transitionIn de customTransitionMixins
     * Afin de définir une animation custom
     *
     * @args {Function} ended - callback à appeler une fois l'animation terminée
     */
    transitionIn (next) {
      const timeline = new TimelineLite({ onComplete: () => {
        // On défini qu'on est plus en transition
        this.isTransitioning = false

        next()
      } })

      // On défini qu'on est en transition
      this.isTransitioning = true

      if (this.fancyZoomAnimation) {
        const bgRect = this.$refs.root.getBoundingClientRect()
        const minHeight = Math.ceil(bgRect.width * (this.clickedThumbRect.height / this.clickedThumbRect.width))
        TweenLite.set(this.$refs.root, {
          minHeight: minHeight,
          height: minHeight,
          overflow: 'hidden',
          scale: this.clickedThumbRect.width / bgRect.width,
          x: this.clickedThumbRect.left - bgRect.left,
          y: this.clickedThumbRect.top - bgRect.top,
          'will-change': 'transform height'
        })

        TweenLite.set(this.$refs.background, {
          x: '-100%',
          'will-change': 'transform',
          backgroundColor: this.COLOR.DARK
        })

        timeline.to(this.$refs.background, 0.8, {
          x: '0%',
          ease: Power3.easeIn
        })

        timeline.to(this.$refs.root, 1.2, {
          scale: 1,
          x: 0,
          y: 0,
          height: bgRect.height,
          clearProps: 'height,minHeight,overflow,transform',
          ease: Power3.easeOut,
          onComplete: () => {
            TweenLite.set(this.$refs.background, {
              clearProps: 'x, will-change, backgroundColor'
            })
          }
        })
      } else {
        // Juste un delai
        // permettant de voir le composant PageTransitionLayer s'animer
        timeline.delay(1.2)
      }
    },
    /**
     * Callback lorsqu'un nouveau chapter est "mounted"
     */
    onChapterMounted (el, index) {
      // On l'ajoute à la liste des chapites
      this.chaptersEls.splice(index, 1, el)
    },
    /**
     * Callback lorsqu'un chapter va être "unmounted"
     */
    onChapterBeforeDestroy (el, index) {
      // On le retire de la liste des chapites
      this.chaptersEls.splice(index, 1)
    }
  }
}
</script>

<style lang="stylus">
  .TourView
    position: relative
    min-height: 100vh
    // overflow: hidden // debug - sinon la position "sticky" ne fonctionne pas - à la base utilisé pour la transition de page, on l'ajoute puis enlève directement en js
    transform-origin top left

    &_bg
      position: absolute
      top 0
      right 0
      bottom 0
      left 0

    &_contentContainer
      position: relative

    .TourListContainer

      position relative

      .BackgroundRelief

        position absolute

    .TourList

      min-height 100vh
      position relative
      background-color $grey-1
      // background-image url('/img/backgrounds/backrelief_right.jpg')
      background-image url('/img/backgrounds/relief_background.jpg')
      background-repeat no-repeat
      background-size cover
      background-position right center

      @media $mq_s_only

        .VerticalScrollList

          padding-top 20vh
          position relative

          .ListItem

            padding-bottom 10px

      .HorizontalScrollList

        height 100vh

        .ScrollIndicator

          display none

        .swiper-container

          width 100%

</style>
